import React from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { PaymentTypesEnum } from '../../shared/constants'
import { useTextResources } from '../../../language';
//import {pickBy} from '../utils'
import _ from 'lodash';



const PaymentTypesDropDown = ({ paymentTypeIds = [], ...props }) => {
    const text = useTextResources();

    //If provided with RateTypeIds, use only those. Otherwise, use the entire Enum
    const options = paymentTypeIds.length
        ? _.pickBy(PaymentTypesEnum, (key) => paymentTypeIds.includes(key))
        : PaymentTypesEnum;

    const data = Object.entries(options).reduce((acc, [key, value]) => {
        acc.push({
            text: text(key),
            value,
        });
        return acc;
    }, []);

    return (
        <DropDown textField='text' valueField='value' data={data} {...props} />
    );
};

PaymentTypesDropDown.propTypes = {
    paymentTypeIds: PropTypes.array,
};

export default PaymentTypesDropDown;
